export default "__VITE_ASSET__d8d10142__"